import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getActiveCustomerCartSkus } from "../utils/getCart"

/**
 * Retrieves the active cart SKUs for a customer
 */
export const queryCustomerCartSkus = {
  async customerCartSkus(_parent, args, context, _info) {
    const { customerId, customerNumber } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.READ,
    })

    if (!customerId || !customerNumber) return null

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customerNumber,
    })

    const skus = await getActiveCustomerCartSkus(customerId, user.employeeNumber)

    return { skus }
  },
}
